import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";

const BASE = "/follow";

export const followApi = {
  follow: (dto: { targetType: string; targetId: string; metadata?: Record<string, unknown> }) =>
    apiPost<{ follow: Record<string, unknown> }>(BASE, dto),

  followBatch: (dtos: Array<{ targetType: string; targetId: string; metadata?: Record<string, unknown> }>) =>
    apiPost<{ follows: Record<string, unknown>[]; count: number }>(`${BASE}/batch`, { dtos }),

  getFollowing: (params?: {
    targetType?: string;
    sortBy?: string;
    order?: "desc" | "asc";
    page?: number;
    limit?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.targetType) searchParams.set("targetType", params.targetType);
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.limit) searchParams.set("limit", String(params.limit));
    return apiGet<{ data: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      `${BASE}?${searchParams.toString()}`,
    );
  },

  getFollowers: (params?: {
    sortBy?: string;
    order?: "desc" | "asc";
    page?: number;
    limit?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.limit) searchParams.set("limit", String(params.limit));
    return apiGet<{ data: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      `${BASE}/followers?${searchParams.toString()}`,
    );
  },

  getTargetFollowers: (targetType: string, targetId: string, params?: {
    sortBy?: string;
    order?: "desc" | "asc";
    page?: number;
    limit?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.limit) searchParams.set("limit", String(params.limit));
    return apiGet<{ data: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      `${BASE}/targets/${targetType}/${targetId}?${searchParams.toString()}`,
    );
  },

  isFollowing: (targetType: string, targetId: string) =>
    apiGet<{ isFollowing: boolean }>(`${BASE}/is-following/${targetType}/${targetId}`),

  getStats: () =>
    apiGet<{ followingCount: number; followersCount: number; byTargetType: Array<{ type: string; count: number }> }>(
      `${BASE}/stats`,
    ),

  getRecommendations: (limit?: number) => {
    const searchParams = new URLSearchParams();
    if (limit) searchParams.set("limit", String(limit));
    return apiGet<{ recommendations: Array<{ type: string; id: string; title?: string; reason?: string; metadata?: Record<string, unknown>; relevance: number }> }>(
      `${BASE}/recommendations?${searchParams.toString()}`,
    );
  },

  unfollow: (targetType: string, targetId: string) =>
    apiDelete<{ message: string }>(`${BASE}/${targetType}/${targetId}`),
};